<template>
    <div class="header">
        <div class="header-box"></div>
    </div>
</template>

<script>
    export default {
        name: "homeHeader",
        data(){
            return{

            }
        },
        mounted() {
        },
        methods:{

        }
    }
</script>

<style scoped lang="scss">
    .header{
        width: 100vw;
        height: 7vh;
        position: absolute;
        top: 0;
        background: url("../assets/img/top-y.png");
        background-size: 100% 100%;
        z-index: 999;
        .header-box{
            height: 6.5vh;
            background: url("../assets/img/header.png");
            background-size: 100% 100%;
        }
    }
</style>